export default {
  xsrf_token: ''
}
